import React from "react";
import { WiStars } from "react-icons/wi";
export default function Product_section() {
  return (
    // <div className="max-w-screen-xl mx-auto px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
    //   <div className="grid grid-cols-1 gap-y-8 lg:grid-cols-2 lg:items-center lg:gap-x-16">
    //     <div className="mx-auto max-w-lg text-left lg:mx-0 ltr:lg:text-left rtl:lg:text-right">
    //       <h2 className="text-3xl font-bold sm:text-5xl mb-10">
    //         PreNexa AI: Your Ultimate PTE Preparation Partner
    //       </h2>

    //       <p className="mt-4 text-gray-600 text-xl">
    //         Prepare for success in PTE examinations like never before with
    //         Prenexa AI, your comprehensive preparation solution powered by
    //         cutting-edge artificial intelligence technology. Tailored
    //         specifically for PTE aspirants, Prenexa AI combines the latest
    //         advancements in AI with expert guidance to elevate your preparation
    //         experience and maximize your chances of success.
    //       </p>

    //       <a className="mt-8  hidden sm:inline-block  rounded bg-gray-900 px-12 py-3 text-sm font-medium text-white transition hover:bg-black focus:outline-none focus:ring focus:ring-yellow-400">
    //         Get Started Today
    //       </a>
    //     </div>

    //     <div className="grid grid-cols-3 gap-4 sm:grid-cols-3 lg:gap-2 ">
    //       <a
    //         className="block rounded-xl border border-gray-100 p-4 shadow-sm hover:border-gray-200 hover:ring-1 hover:ring-gray-200 focus:outline-none focus:ring"
    //         href="/"
    //       >
    //         <span className="inline-block rounded-lg bg-gray-50 p-3">
    //           <svg
    //             className="h-6 w-6"
    //             fill="none"
    //             stroke="currentColor"
    //             viewBox="0 0 24 24"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <path d="M12 14l9-5-9-5-9 5 9 5z"></path>
    //             <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"></path>
    //             <path
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //               strokeWidth="2"
    //               d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
    //             ></path>
    //           </svg>
    //         </span>

    //         <h2 className="mt-2 font-bold">AI-Powered Learning</h2>

    //         <p className="hidden sm:mt-1 sm:block sm:text-sm sm:text-gray-600">
    //           Experience personalized study plans and adaptive learning pathways
    //           driven by AI algorithms, tailored to your unique strengths and
    //           areas for improvement.
    //         </p>
    //       </a>

    //       <a
    //         className="block rounded-xl border border-gray-100 p-4 shadow-sm hover:border-gray-200 hover:ring-1 hover:ring-gray-200 focus:outline-none focus:ring"
    //         href="/"
    //       >
    //         <span className="inline-block rounded-lg bg-gray-50 p-3">
    //           <svg
    //             className="h-6 w-6"
    //             fill="none"
    //             stroke="currentColor"
    //             viewBox="0 0 24 24"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <path d="M12 14l9-5-9-5-9 5 9 5z"></path>
    //             <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"></path>
    //             <path
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //               strokeWidth="2"
    //               d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
    //             ></path>
    //           </svg>
    //         </span>

    //         <h2 className="mt-2 font-bold">Comprehensive Resources</h2>

    //         <p className="hidden sm:mt-1 sm:block sm:text-sm sm:text-gray-600">
    //           Gain access to a wealth of study materials, practice tests,
    //           interactive exercises, and simulated exam environments,
    //           meticulously curated to mirror the format and content of PTE exams.
    //         </p>
    //       </a>

    //       <a
    //         className="block rounded-xl border border-gray-100 p-4 shadow-sm hover:border-gray-200 hover:ring-1 hover:ring-gray-200 focus:outline-none focus:ring"
    //         href="/"
    //       >
    //         <span className="inline-block rounded-lg bg-gray-50 p-3">
    //           <svg
    //             className="h-6 w-6"
    //             fill="none"
    //             stroke="currentColor"
    //             viewBox="0 0 24 24"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <path d="M12 14l9-5-9-5-9 5 9 5z"></path>
    //             <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"></path>
    //             <path
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //               strokeWidth="2"
    //               d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
    //             ></path>
    //           </svg>
    //         </span>

    //         <h2 className="mt-2 font-bold">Real-Time Feedback</h2>

    //         <p className="hidden sm:mt-1 sm:block sm:text-sm sm:text-gray-600">
    //           Receive instant feedback on your performance, with detailed
    //           insights by our AI-powered analysis tools to help you track your
    //           progress and focus on areas that need refinement.
    //         </p>
    //       </a>

    //       <a
    //         className="block rounded-xl border border-gray-100 p-4 shadow-sm hover:border-gray-200 hover:ring-1 hover:ring-gray-200 focus:outline-none focus:ring"
    //         href="/"
    //       >
    //         <span className="inline-block rounded-lg bg-gray-50 p-3">
    //           <svg
    //             className="h-6 w-6"
    //             fill="none"
    //             stroke="currentColor"
    //             viewBox="0 0 24 24"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <path d="M12 14l9-5-9-5-9 5 9 5z"></path>
    //             <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"></path>
    //             <path
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //               strokeWidth="2"
    //               d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
    //             ></path>
    //           </svg>
    //         </span>

    //         <h2 className="mt-2 font-bold">Practice Exams</h2>

    //         <p className="hidden sm:mt-1 sm:block sm:text-sm sm:text-gray-600">
    //           Familiarize yourself with the exam format and timing through our
    //           extensive collection of practice exams, designed to simulate the
    //           real PTE  testing experience.{" "}
    //         </p>
    //       </a>

    //       <a
    //         className="block rounded-xl border border-gray-100 p-4 shadow-sm hover:border-gray-200 hover:ring-1 hover:ring-gray-200 focus:outline-none focus:ring"
    //         href="/"
    //       >
    //         <span className="inline-block rounded-lg bg-gray-50 p-3">
    //           <svg
    //             className="h-6 w-6"
    //             fill="none"
    //             stroke="currentColor"
    //             viewBox="0 0 24 24"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <path d="M12 14l9-5-9-5-9 5 9 5z"></path>
    //             <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"></path>
    //             <path
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //               strokeWidth="2"
    //               d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
    //             ></path>
    //           </svg>
    //         </span>

    //         <h2 className="mt-2 font-bold">Vocabulary Builder</h2>

    //         <p className="hidden sm:mt-1 sm:block sm:text-sm sm:text-gray-600">
    //           Expand your vocabulary and improve your language proficiency with
    //           our comprehensive vocabulary builder tool, tailored to the
    //           specific requirements of PTE exams.{" "}
    //         </p>
    //       </a>

    //       <a
    //         className="block rounded-xl border border-gray-100 p-4 shadow-sm hover:border-gray-200 hover:ring-1 hover:ring-gray-200 focus:outline-none focus:ring"
    //         href="/"
    //       >
    //         <span className="inline-block rounded-lg bg-gray-50 p-3">
    //           <svg
    //             className="h-6 w-6"
    //             fill="none"
    //             stroke="currentColor"
    //             viewBox="0 0 24 24"
    //             xmlns="http://www.w3.org/2000/svg"
    //           >
    //             <path d="M12 14l9-5-9-5-9 5 9 5z"></path>
    //             <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"></path>
    //             <path
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //               strokeWidth="2"
    //               d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
    //             ></path>
    //           </svg>
    //         </span>

    //         <h2 className="mt-2 font-bold">Speaking and Writing Feedback</h2>

    //         <p className="hidden sm:mt-1 sm:block sm:text-sm sm:text-gray-600">
    //           Receive constructive feedback on your speaking and writing tasks,
    //           with AI-powered analysis tools providing detailed evaluations and
    //           suggestions for improvement.
    //         </p>
    //       </a>
    //     </div>
    //   </div>
    // </div>
    <div>
      {/*
  Heads up! 👋

  This component comes with some `rtl` classes. Please remove them if they are not needed in your project.
*/}

      <section className="overflow-hidden bg-gray-50 sm:grid sm:grid-cols-2 sm:items-center mb-10">
        <div className="p-8 md:p-12 lg:px-16 lg:py-24">
          <div className="mx-auto max-w-xl text-center ltr:sm:text-left rtl:sm:text-right">
            <h1 className="text-3xl font-bold sm:text-5xl mb-10 text-left">
            PrepNexis AI: Your Ultimate PTE Preparation Partner
            </h1>
            <p className="hidden text-gray-500 md:mt-4 md:block text-left text-lg">
              Prepare for success in your PTE Academic exam with PrepNexis AI —
              an advanced AI-powered platform offering full-length PTE mock
              tests, real-time speaking and writing evaluation, and detailed
              performance analytics. Designed specifically for PTE aspirants,
              PrepNexis combines smart technology with expert strategies to
              enhance your test preparation and boost your score efficiently.
            </p>
            <div className="mt-4 md:mt-8">
              <div className="text-left">
                <a
                  href="/signup"
                  className="bg-gradient-to-r from-gray-600 via-gray-800 to-gray-900 text-white px-6 py-3 rounded-sm font-medium transition transform hover:scale-105 inline-flex items-center"
                >
                  <WiStars className="w-5 h-5" />
                  <span className="px-2">Get Your Free Access Today</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <img
          alt=""
          src="/image/23.png"
          className="h-full w-full object-cover sm:h-[calc(100%_-_2rem)] sm:self-end sm:rounded-ss-[30px] md:h-[calc(100%_-_4rem)] md:rounded-ss-[60px]"
        />
      </section>
    </div>
  );
}
